import React, {Component} from 'react';
import {FaIcon} from "../FaIcon";
import {TiktokLogo} from "../logos/TiktokLogo";
import {LinkedinLogo} from "../logos/LinkedinLogo";
import {DV360Logo} from "../logos/DV360Logo";
import {TiendaNubeLogo} from "../logos/TiendaNubeLogo";
import {ShopifyLogo} from "../logos/ShopifyLogo";
import {WooCommerceLogo} from "../logos/WooCommerceLogo";
import {VtexLogo} from "../logos/VtexLogo";
import { withTranslation } from 'react-i18next';


class DashboardPlatformFilterClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            platform: this.props.platformFilter,
        };
        this.handlePlatformFilterChange = this.handlePlatformFilterChange.bind(this);
        this.handlePlatformFilterSheetClick = this.handlePlatformFilterSheetClick.bind(this);
        this.handlePlatformFilterFacebookClick = this.handlePlatformFilterFacebookClick.bind(this);
        this.handlePlatformFilterGoogleClick = this.handlePlatformFilterGoogleClick.bind(this);
        this.handlePlatformFilterTiktokClick = this.handlePlatformFilterTiktokClick.bind(this);
        this.handlePlatformFilterLinkedinClick = this.handlePlatformFilterLinkedinClick.bind(this);
        this.handlePlatformFilterDV360Click = this.handlePlatformFilterDV360Click.bind(this);
        this.handlePlatformFilterTiendaNubeClick = this.handlePlatformFilterTiendaNubeClick.bind(this);
        this.handlePlatformFilterShopifyClick = this.handlePlatformFilterShopifyClick.bind(this);
        this.handlePlatformFilterWooCommerceClick = this.handlePlatformFilterWooCommerceClick.bind(this);
        this.handlePlatformFilterVtexClick = this.handlePlatformFilterVtexClick.bind(this);
    }

    componentDidUpdate(prevProps) {
        // Verificar si cada propiedad relevante ha cambiado
        if (prevProps.platformFilter !== this.props.platformFilter) {
            this.setState({ platform: this.props.platformFilter });
        }
    }

    handlePlatformFilterChange(filterValue) {
        this.props.onPlatformFilterChange(filterValue);
    }

    handlePlatformFilterSheetClick(event) {
        event.preventDefault();
        let newPlatform = '';
        if (this.state.platform !== 'sheet') {
            newPlatform = 'sheet';
        }
        this.setState({platform: newPlatform});
        this.handlePlatformFilterChange(newPlatform)
    }

    handlePlatformFilterFacebookClick(event) {
        event.preventDefault();
        let newPlatform = '';
        if (this.state.platform !== 'facebook') {
            newPlatform = 'facebook';
        }
        this.setState({platform: newPlatform});
        this.handlePlatformFilterChange(newPlatform)
    }

    handlePlatformFilterGoogleClick(event) {
        event.preventDefault();
        let newPlatform = '';
        if (this.state.platform !== 'google') {
            newPlatform = 'google';
        }
        this.setState({platform: newPlatform});
        this.handlePlatformFilterChange(newPlatform)
    }

    handlePlatformFilterTiktokClick(event) {
        event.preventDefault();
        let newPlatform = '';
        if (this.state.platform !== 'tiktok') {
            newPlatform = 'tiktok';
        }
        this.setState({platform: newPlatform});
        this.handlePlatformFilterChange(newPlatform)
    }

    handlePlatformFilterLinkedinClick(event) {
        event.preventDefault();
        let newPlatform = '';
        if (this.state.platform !== 'linkedin') {
            newPlatform = 'linkedin';
        }
        this.setState({platform: newPlatform});
        this.handlePlatformFilterChange(newPlatform)
    }

    handlePlatformFilterDV360Click(event) {
        event.preventDefault();
        let newPlatform = '';
        if (this.state.platform !== 'dv360') {
            newPlatform = 'dv360';
        }
        this.setState({platform: newPlatform});
        this.handlePlatformFilterChange(newPlatform)
    }

    handlePlatformFilterTiendaNubeClick(event) {
        event.preventDefault();
        let newPlatform = '';
        if (this.state.platform !== 'tienda_nube') {
            newPlatform = 'tienda_nube';
        }
        this.setState({platform: newPlatform});
        this.handlePlatformFilterChange(newPlatform)
    }

    handlePlatformFilterShopifyClick(event) {
        event.preventDefault();
        let newPlatform = '';
        if (this.state.platform !== 'shopify') {
            newPlatform = 'shopify';
        }
        this.setState({platform: newPlatform});
        this.handlePlatformFilterChange(newPlatform)
    }

    handlePlatformFilterWooCommerceClick(event) {
        event.preventDefault();
        let newPlatform = '';
        if (this.state.platform !== 'woocommerce') {
            newPlatform = 'woocommerce';
        }
        this.setState({platform: newPlatform});
        this.handlePlatformFilterChange(newPlatform)
    }

    handlePlatformFilterVtexClick(event) {
        event.preventDefault();
        let newPlatform = '';
        if (this.state.platform !== 'vtex') {
            newPlatform = 'vtex';
        }
        this.setState({platform: newPlatform});
        this.handlePlatformFilterChange(newPlatform)
    }

    getSheetClass() {
        return "dashboard-sheet-filter" + (this.state.platform === 'sheet' ? ' active' : '');
    }

    getFacebookClass() {
        return "dashboard-facebook-filter" + (this.state.platform === 'facebook' ? ' active' : '');
    }

    getGoogleClass() {
        return "dashboard-google-filter" + (this.state.platform === 'google' ? ' active' : '');
    }

    getTiktokClass() {
        return "dashboard-tiktok-filter" + (this.state.platform === 'tiktok' ? ' active' : '');
    }

    getLinkedinClass() {
        return "dashboard-linkedin-filter" + (this.state.platform === 'linkedin' ? ' active' : '');
    }

    getDV360Class() {
        return "dashboard-dv360-filter" + (this.state.platform === 'dv360' ? ' active' : '');
    }

    getTiendaNubeClass() {
        return "dashboard-tiendanube-filter" + (this.state.platform === 'tienda_nube' ? ' active' : '');
    }

    getShopifyClass() {
        return "dashboard-shopify-filter" + (this.state.platform === 'shopify' ? ' active' : '');
    }

    getWooCommerceClass() {
        return "dashboard-woocommerce-filter" + (this.state.platform === 'woocommerce' ? ' active' : '');
    }

    getVtexClass() {
        return "dashboard-vtex-filter" + (this.state.platform === 'vtex' ? ' active' : '');
    }

    getTiktokIsSelected() {
        return (this.state.platform === 'tiktok');
    }

    getLinkedinIsSelected() {
        return (this.state.platform === 'linkedin');
    }

    getDV360IsSelected() {
        return (this.state.platform === 'dv360');
    }

    getTiendaNubeIsSelected() {
        return (this.state.platform === 'tienda_nube');
    }

    getShopifyIsSelected() {
        return (this.state.platform === 'shopify');
    }

    getWooCommerceIsSelected() {
        return (this.state.platform === 'woocommerce');
    }

    getVtexIsSelected() {
        return (this.state.platform === 'vtex');
    }

    renderFacebookTooltip() {
        const { t } = this.props;
        return (
            <div className="column-description">
                <p>{t('dashboard_platform_filter.show_only_facebook_ads')}</p>
            </div>
        )
    }

    renderSheetTooltip() {
        const { t } = this.props;
        return (
            <div className="column-description">
                <p>{t('dashboard_platform_filter.show_only_sheets')}</p>
            </div>
        )
    }

    renderTiktokTooltip() {
        const { t } = this.props;
        return (
            <div className="column-description">
                <p>{t('dashboard_platform_filter.show_only_tiktok_ads')}</p>
            </div>
        )
    }

    renderLinkedinTooltip() {
        const { t } = this.props;
        return (
            <div className="column-description">
                <p>{t('dashboard_platform_filter.show_only_linkedin_ads')}</p>
            </div>
        )
    }

    renderDV360Tooltip() {
        const { t } = this.props;
        return (
            <div className="column-description">
                <p>{t('dashboard_platform_filter.show_only_dv360')}</p>
            </div>
        )
    }

    renderGoogleTooltip() {
        const { t } = this.props;
        return (
            <div className="column-description">
                <p>{t('dashboard_platform_filter.show_only_google_ads')}</p>
            </div>
        )
    }

    renderTiendaNubeTooltip() {
        const { t } = this.props;
        return (
            <div className="column-description">
                <p>{t('dashboard_platform_filter.show_only_tiendanube')}</p>
            </div>
        )
    }

    renderShopifyTooltip() {
        const { t } = this.props;
        return (
            <div className="column-description">
                <p>{t('dashboard_platform_filter.show_only_shopify')}</p>
            </div>
        )
    }

    renderWooCommerceTooltip() {
        const { t } = this.props;
        return (
            <div className="column-description">
                <p>{t('dashboard_platform_filter.show_only_woocommerce')}</p>
            </div>
        )
    }

    renderVtexTooltip() {
        const { t } = this.props;
        return (
            <div className="column-description">
                <p>{t('dashboard_platform_filter.show_only_vtex')}</p>
            </div>
        )
    }

    render() {
        return (
            <div className="filter-options mr-3">
                <div className="filter-platform-sheet filter-input">
                    <button onClick={this.handlePlatformFilterSheetClick}
                            className={this.getSheetClass()}>
                        <FaIcon iconName="table"/>
                    </button>
                    {this.renderSheetTooltip()}
                </div>
                <div className="filter-platform-facebook filter-input">
                    <button onClick={this.handlePlatformFilterFacebookClick}
                            className={this.getFacebookClass()}>
                        <FaIcon prefix="fab" iconName="facebook"/>
                    </button>
                    {this.renderFacebookTooltip()}
                </div>
                <div className="filter-platform-google filter-input">
                    <button onClick={this.handlePlatformFilterGoogleClick}
                            className={this.getGoogleClass()}>
                        <FaIcon prefix="fab" iconName="google"/>
                    </button>
                    {this.renderGoogleTooltip()}
                </div>
                <div className="filter-platform-tiktok filter-input">
                    <button onClick={this.handlePlatformFilterTiktokClick}
                            className={this.getTiktokClass()}>
                        <TiktokLogo hspace={0} vspace={0} isColoredOnHover={true}
                                    width={17} height={17}
                                    styles={{marginTop:'-3px'}}
                                    renderVeryColoredVersion={this.getTiktokIsSelected()} />
                    </button>
                    {this.renderTiktokTooltip()}
                </div>
                <div className="filter-platform-linkedin filter-input">
                    <button onClick={this.handlePlatformFilterLinkedinClick}
                            className={this.getLinkedinClass()}>
                        <LinkedinLogo hspace={0} vspace={0} isColoredOnHover={true}
                                    width={17} height={17}
                                    styles={{marginTop:'-3px'}}
                                    renderVeryColoredVersion={this.getLinkedinIsSelected()} />
                    </button>
                    {this.renderLinkedinTooltip()}
                </div>
                <div className="filter-platform-dv360 filter-input">
                    <button onClick={this.handlePlatformFilterDV360Click}
                            className={this.getDV360Class()}>
                        <DV360Logo hspace={0} vspace={0} isColoredOnHover={true}
                                    width={17} height={17}
                                    styles={{marginTop:'-3px'}}
                                    renderVeryColoredVersion={this.getDV360IsSelected()} />
                    </button>
                    {this.renderDV360Tooltip()}
                </div>
                <div className="filter-platform-tiendanube filter-input">
                    <button onClick={this.handlePlatformFilterTiendaNubeClick}
                            className={this.getTiendaNubeClass()}>
                        <TiendaNubeLogo hspace={0} vspace={0} isColoredOnHover={true}
                                    width={17} height={17}
                                    styles={{marginTop:'-3px'}}
                                    renderVeryColoredVersion={this.getTiendaNubeIsSelected()} />
                    </button>
                    {this.renderTiendaNubeTooltip()}
                </div>
                <div className="filter-platform-shopify filter-input">
                    <button onClick={this.handlePlatformFilterShopifyClick}
                            className={this.getShopifyClass()}>
                        <ShopifyLogo hspace={0} vspace={0} isColoredOnHover={true}
                                    width={17} height={17}
                                    styles={{marginTop:'-3px'}}
                                    renderVeryColoredVersion={this.getShopifyIsSelected()} />
                    </button>
                    {this.renderShopifyTooltip()}
                </div>
                <div className="filter-platform-woocommerce filter-input">
                    <button onClick={this.handlePlatformFilterWooCommerceClick}
                            className={this.getWooCommerceClass()}>
                        <WooCommerceLogo hspace={0} vspace={0} isColoredOnHover={true}
                                    width={17} height={17}
                                    styles={{marginTop:'-3px'}}
                                    renderVeryColoredVersion={this.getWooCommerceIsSelected()} />
                    </button>
                    {this.renderWooCommerceTooltip()}
                </div>
                <div className="filter-platform-vtex filter-input">
                    <button onClick={this.handlePlatformFilterVtexClick}
                            className={this.getVtexClass()}>
                        <VtexLogo hspace={0} vspace={0} isColoredOnHover={true}
                                    width={17} height={17}
                                    styles={{marginTop:'-3px'}}
                                    renderVeryColoredVersion={this.getVtexIsSelected()} />
                    </button>
                    {this.renderVtexTooltip()}
                </div>
            </div>
        )
    }
}

export const DashboardPlatformFilter = withTranslation()(DashboardPlatformFilterClass);
export default DashboardPlatformFilter;